import { createTheme, type PaletteMode } from "@mui/material";

export function buildTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#E96B56" },
            secondary: { main: "#1E293B" },
            error: { main: "#EF4444" },
            success: { main: "#10B981" },
            warning: { main: "#F59E0B" },
            background: { default: "#F8FAFC", paper: "#FFFFFF" },
          }
        : {
            primary: { main: "#FF8A73" },
            secondary: { main: "#94A3B8" },
            error: { main: "#EF5350" },
            success: { main: "#34D399" },
            warning: { main: "#FBBF24" },
            background: { default: "#0F172A", paper: "#1E293B" },
          }),
    },
    typography: {
      fontFamily: "'Inter', sans-serif",
    },
    shape: { borderRadius: 12 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 9999,
            fontWeight: 500,
          },
        },
        defaultProps: {
          disableElevation: true,
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            border: "1px solid",
            borderColor: mode === "light" ? "#F0F0F0" : "#334155",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 9999,
            "&.Mui-selected": {
              backgroundColor:
                mode === "light" ? "#FDECE9" : "rgba(255,138,115,0.15)",
              color: mode === "light" ? "#E96B56" : "#FF8A73",
              "&:hover": {
                backgroundColor:
                  mode === "light" ? "#FBD9D3" : "rgba(255,138,115,0.25)",
              },
            },
          },
        },
      },
    },
  });
}
